import { AmpiBanner } from 'components/Banners'
import Link from 'next/link'
import { ComponentType } from 'react'
import { Col, Container, Row } from 'reactstrap'

export const FooterDesktop: ComponentType = () => (
  <div className="px-20 pb-20">
    <div className="bg-porcelain rounded-lg pt-85 pb-40 print--none">
      <Container>
        <Row>
          <Col lg={3}>
            <img alt="Yucatan Premier" src="/images/yp-brand.svg" width="193px" height="89px" />
          </Col>
          <Col lg={9}>
            <div className="px-15">
              <Row>
                <Col>
                  <h6 className="text-uppercase text-raven font-size-14 font-weight-bold mb-15">Servicios</h6>
                  <ul className="list-unstyled">
                    <li className="py-3px">
                      <Link href="/explorar/operacion/[roleSlug]" as="/explorar/operacion/en-venta">
                        <a title="Comprar" className="text-raven text-nowrap font-size-14">
                          Comprar
                        </a>
                      </Link>
                    </li>
                    <li className="py-3px">
                      <Link href="/explorar/operacion/[roleSlug]" as="/explorar/operacion/en-renta">
                        <a title="Rentar" className="text-raven text-nowrap font-size-14">
                          Rentar
                        </a>
                      </Link>
                    </li>
                    <li className="py-3px">
                      <Link href="/acerca/promueve-tu-propiedad">
                        <a title="Promover mi propiedad" className="text-malachite text-nowrap font-size-14 font-weight-bold">
                          Promover mi propiedad
                        </a>
                      </Link>
                    </li>
                  </ul>
                </Col>
                <Col>
                  <h6 className="text-uppercase text-raven font-size-14 font-weight-bold mb-15">Blog</h6>
                  <ul className="list-unstyled">
                    <li className="py-3px">
                      <Link href="/blog">
                        <a title="Nuestro Blog" className="text-raven text-nowrap font-size-14">
                          Nuestro Blog
                        </a>
                      </Link>
                    </li>
                  </ul>
                </Col>
                <Col>
                  <h6 className="text-uppercase text-raven font-size-14 font-weight-bold mb-15">Compañía</h6>
                  <ul className="list-unstyled">
                    <li className="py-3px">
                      <Link href="/acerca">
                        <a title="Sobre Nosotros" className="text-raven text-nowrap font-size-14">
                          Sobre Nosotros
                        </a>
                      </Link>
                    </li>
                    <li className="py-3px">
                      <Link href="/acerca/asesores">
                        <a title="Asesores Certificados" className="text-raven text-nowrap font-size-14">
                          Asesores Certificados
                        </a>
                      </Link>
                    </li>
                    <li className="py-3px">
                      <Link href="/acerca/testimoniales">
                        <a title="Testimoniales" className="text-raven text-nowrap font-size-14">
                          Testimoniales
                        </a>
                      </Link>
                    </li>
                  </ul>
                </Col>
                <Col>
                  <h6 className="text-uppercase text-raven font-size-14 font-weight-bold mb-15">Contacto</h6>
                  <ul className="list-unstyled">
                    <li className="py-3px">
                      <Link href="/acerca/contacto">
                        <a title="Contáctanos" className="text-raven text-nowrap font-size-14">
                          Contáctanos
                        </a>
                      </Link>
                    </li>
                    <li className="py-3px">
                      <a
                        title="Llámanos al 999 944-1214"
                        href="tel:9999441214"
                        className="text-raven text-nowrap font-size-14"
                      >
                        Llámanos al 999 944-1214
                      </a>
                    </li>
                    <li className="py-3px">
                      <a
                        title="Escríbenos por WhatsApp"
                        href="https://wa.me/5219993351899"
                        className="text-raven font-size-14 text-nowrap font-weight-bold"
                        target="_blank"
                      >
                        Escríbenos por WhatsApp
                      </a>
                    </li>
                    <li className="py-3px">
                      <a
                        title="Escríbenos a info@yucatanpremier.com"
                        href="mailto:info@yucatanpremier.com"
                        className="text-raven text-nowrap font-size-14"
                      >
                        Escríbenos a info@yucatanpremier.com
                      </a>
                    </li>
                  </ul>
                </Col>
                <Col>
                  <h6 className="text-uppercase text-raven font-size-14 font-weight-bold mb-15">Internet</h6>
                  <ul className="list-unstyled mb-0">
                    <li className="py-3px">
                      <a
                        title="Facebook"
                        href="https://www.facebook.com/yucatanpremier"
                        target="_blank"
                        className="text-raven text-nowrap font-size-14"
                      >
                        Facebook
                      </a>
                    </li>
                    <li className="py-3px">
                      <a
                        title="Instagram"
                        href="https://www.instagram.com/yucatanpremier"
                        target="_blank"
                        className="text-raven text-nowrap font-size-14"
                      >
                        Instagram
                      </a>
                    </li>
                    <li className="py-3px">
                      <a
                        title="Twitter"
                        href="https://twitter.com/yucatanpremier"
                        target="_blank"
                        className="text-raven text-nowrap font-size-14"
                      >
                        Twitter
                      </a>
                    </li>
                  </ul>
                </Col>
              </Row>
            </div>
            <div className="mt-55 pb-100">
              <AmpiBanner />
            </div>
            <div className="px-15 d-flex justify-content-between">
              <ul className="list-unstyled d-flex mb-0">
                <li className="pr-3">
                  <Link href="/legal/politica-de-servicio">
                    <a title="Política de Servicio" className="text-gray-chateau font-size-14">
                      Política de Servicio
                    </a>
                  </Link>
                </li>
                <li className="px-3">
                  <Link href="/legal/aviso-de-privacidad">
                    <a title="Aviso de Privacidad" className="text-gray-chateau font-size-14">
                      Aviso de Privacidad
                    </a>
                  </Link>
                </li>
                <li className="px-3">
                  <a
                    href="https://yucatanpremier.com.mx/sitemap.xml"
                    title="Mapa del Sitio"
                    className="text-gray-chateau font-size-14"
                    target="_blank"
                  >
                    Mapa del Sitio
                  </a>
                </li>
              </ul>
              <span className="text-gray-chateau font-size-14">© {new Date().getFullYear()} Yucatán Premier</span>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  </div>
)
